var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrismLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 587,
    height: 587,
    viewBox: "0 0 587 587",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5385_28235",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 588,
    height: 587
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 293.499,
    cy: 293.5,
    r: 293.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5385_28235)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.983,
    y: -186.645,
    width: 84.1509,
    height: 783.833,
    transform: "rotate(30 220.983 -186.645)",
    fill: "#86BC25",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.854,
    y: -144.559,
    width: 84.1509,
    height: 783.833,
    transform: "rotate(30 293.854 -144.559)",
    fill: "#C4D600",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.737,
    y: -102.48,
    width: 84.1509,
    height: 783.833,
    transform: "rotate(30 366.737 -102.48)",
    fill: "#E3E48D",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.385 -119.887L179.702 -162.216L485.856 368.057L415.069 368.057L388.1 368.057L106.385 -119.887Z",
    fill: "#9DD4CF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.702 -162.215L253.019 -204.544L583.719 368.246L519.108 368.246L486.253 368.246L179.702 -162.215Z",
    fill: "#6FC2B4",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.034,
    y: -204.539,
    width: 84.6593,
    height: 657.712,
    transform: "rotate(-30 253.034 -204.539)",
    fill: "#007680",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -59.1421,
    y: 451.914,
    width: 83.9616,
    height: 757.843,
    transform: "rotate(-90 -59.1421 451.914)",
    fill: "#A0DCFF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -59.1421,
    y: 535.887,
    width: 83.9616,
    height: 757.843,
    transform: "rotate(-90 -59.1421 535.887)",
    fill: "#62B5E5",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -59.1421,
    y: 619.824,
    width: 83.9616,
    height: 757.843,
    transform: "rotate(-90 -59.1421 619.824)",
    fill: "#007CB0",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrismLogo);
export default __webpack_public_path__ + "static/media/prism_logo.620d24fee6f92e83ced446ad72d3bd1f.svg";
export { ForwardRef as ReactComponent };